import { useEffect, useState } from "react";
import api from "@/lib/api";
import PfmpChecklistDialog from "@/components/PfmpChecklistDialog";
import { CalendarDays, Briefcase, ClipboardCheck } from "lucide-react";

export default function PfmpCountdown() {
  const [pfmp, setPfmp] = useState(null);
  const [checklistOpen, setChecklistOpen] = useState(false);

  useEffect(() => {
    api.get("/pfmp/next").then(({ data }) => setPfmp(data)).catch(() => {});
  }, []);

  if (!pfmp) return null;

  return (
    <>
      <div className="rounded-3xl bg-gradient-to-r from-sky-500 to-sky-600 text-white shadow-sm px-6 py-4 flex items-center gap-4 flex-wrap" data-testid="pfmp-countdown">
        <div className="h-12 w-12 rounded-2xl bg-white/20 flex items-center justify-center shrink-0">
          {pfmp.in_progress ? <Briefcase className="h-6 w-6" /> : <CalendarDays className="h-6 w-6" />}
        </div>
        {pfmp.in_progress ? (
          <div className="min-w-0 flex-1">
            <p className="font-display text-lg font-semibold leading-tight" data-testid="pfmp-countdown-title">Ta PFMP est en cours !</p>
            <p className="text-sky-100 text-sm font-medium">{pfmp.title} · {pfmp.period} — pense à tes fiches portfolio.</p>
          </div>
        ) : (
          <div className="flex items-center gap-4 min-w-0 flex-1 flex-wrap">
            <span className="font-display text-3xl font-semibold shrink-0" data-testid="pfmp-countdown-days">J-{pfmp.days_until}</span>
            <div className="min-w-0">
              <p className="font-bold leading-tight">avant ta {pfmp.title}</p>
              <p className="text-sky-100 text-sm font-medium">{pfmp.period}</p>
            </div>
          </div>
        )}
        <button onClick={() => setChecklistOpen(true)} data-testid="pfmp-prepare-btn"
          className="inline-flex items-center gap-1.5 bg-white/15 hover:bg-white/25 border border-white/30 rounded-full px-4 py-2 text-sm font-bold transition-colors shrink-0">
          <ClipboardCheck className="h-4 w-4" /> Préparer ma PFMP
        </button>
      </div>
      <PfmpChecklistDialog pfmp={pfmp} open={checklistOpen} onOpenChange={setChecklistOpen} />
    </>
  );
}
